// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"367":"493faf62","408":"5eb862a7"}[chunkId] + ".chunk.js";
};